export const YoutubePosts = [
  {
    id: 1,
    url: "https://www.youtube.com/watch?v=jYfkZPS2cGU&ab_channel=canterburymedia",
    caption: "Presentation on Climate Change",
    description:
      "United Nations • Climate change refers to long-term shifts in temperatures and weather patterns. Human activities have been the main driver of climate change, primarily due to the burning of fossil fuels like coal, oil and gas.",
  },
  {
    id: 2,
    url: "https://www.youtube.com/watch?v=6W3g3NzWkbc&ab_channel=canterburymedia",
    caption: "ISA Trip to Epe Fish Market",
    description: "",
  },
  {
    id: 3,
    url: "https://www.youtube.com/watch?v=ES-G178HMOM&ab_channel=canterburymedia",
    caption: "ISA French Drama Presentation",
    description: "",
  },
  {
    id: 4,
    url: "https://www.youtube.com/watch?v=dADmWfETLMg&ab_channel=canterburymedia",
    caption: "VIRTUAL MEETING WITH PARTNER SCHOOL DAY 1",
    description: "",
  },
  {
    id: 5,
    url: "https://www.youtube.com/watch?v=SVVJGLA0Cfw&ab_channel=canterburymedia",
    caption: "IRTUAL MEETING WITH PARTNER SCHOOL DAY 2",
    description: "",
  },
  {
    id: 6,
    url: "https://www.youtube.com/watch?v=N4rfKlR10Zo&ab_channel=canterburymedia",
    caption: "VIRTUAL MEETING WITH PARTNER SCHOOL DAY 3",
    description: "",
  },
  {
    id: 7,
    url: "https://www.youtube.com/watch?v=7neHtsBrvOY&ab_channel=canterburymedia",
    caption: "ISA VISIT TO LOW INCOME SCHOOL",
    description: "",
  },
];
